export const SERVICEID_EMAILJS = "service_yljuevi";

export const TEMPLATEID_EMAILJS = "template_cbupiej";

export const PUBLIC_KEY_EMAILJS = "woW8VmJS86q8fXIoF";
